<div class="info-container">
  <img
    src="../../../../../assets/icons//svg/ic-warning-grey.svg"
    width="25px"
  />
  <p>{{ message }}</p>
</div>
